import { FC } from 'react';

import { H2, Modal } from '@smartshell/ui-kit';

import { IBaseModalProps } from '../interfaces';
import s from './CashBoxModal.module.scss';
import { Cashbox } from './components';

export const CashBoxModal: FC<IBaseModalProps> = ({ onClose }) => {
  return (
    <Modal className={s.modal} onClose={onClose}>
      <div className={s.container}>
        <div className={s.header}>
          <H2>Касса и система налогообложения</H2>
          <span className={s.subtitle}>
            Подключите кассы, выберите категории продаж, укажите для них систему
            налогообложения и тип налога.
          </span>
        </div>

        <Cashbox onClose={onClose} />
      </div>
    </Modal>
  );
};
